export namespace StatusEnum {
  export const displayStatus = Object.freeze({
    active: 'ACTIVE',
    inActive: 'INACTIVE',
  });
}
